function subdomainIsValid(subdomain) {
  if (subdomain === 'sidbi' || subdomain === 'le' || subdomain === 'udyamita') return true;
  return false;
}

exports.subdomainIsValid = subdomainIsValid;